const equivalentKey = (eq) => `${eq.type}:${eq.id}`;

/** Remove duplicatas preservando a ordem (ownIds antes dos equivalentes resolvidos). */
export function dedupeEquivalentIds(list) {
  const seen = new Set();
  return list.filter((eq) => {
    const key = equivalentKey(eq);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/**
 * equivalentIds no Firestore apontam para o doc de outro produto/plano/curso.
 * Para permissionamento, precisamos dos ids de pagamento (ownIds) desses docs.
 */
export function resolveCatalogAccessIds(product, catalogByDocId) {
  const own = product?.ownIds?.length
    ? product.ownIds
    : [{ id: product?.productId, type: product?.type }];

  const fromEquivalents = (product?.equivalentIds ?? []).flatMap((eq) => {
    const target = catalogByDocId.get(eq.id);
    if (target?.ownIds?.length) return target.ownIds;
    // Legado / IAP: doc id pode coincidir com productId, ou id já é de pagamento.
    return [{ id: eq.id, type: eq.type }];
  });

  return dedupeEquivalentIds([...own, ...fromEquivalents]);
}

/** Anexa `accessIds` resolvidos a cada item — usado por getCatalogGroup / hasProductAccess. */
export function attachCatalogAccessIds(catalogProducts = []) {
  const byDocId = new Map(catalogProducts.map((product) => [product.id, product]));

  return catalogProducts.map((product) => ({
    ...product,
    accessIds: resolveCatalogAccessIds(product, byDocId),
  }));
}
